import { ApiError } from '@nucleus-commerce/api-client/transport';

/**
 * How a Google callback failed. The 403s carry their own code: no account uses the Google email
 * (accounts come from invitations), Google has not verified the email, or the account is not
 * active; a 403 without one of those codes reads as no account. Google refused the code (401),
 * the state is bad or expired (422), or anything else.
 */
export type GoogleFailure =
  'noAccount' | 'unverified' | 'inactive' | 'refused' | 'expired' | 'failed';

export function googleFailure(error: unknown): GoogleFailure {
  if (!(error instanceof ApiError)) return 'failed';
  if (error.code === 'GOOGLE_EMAIL_UNVERIFIED') return 'unverified';
  if (error.code === 'ACCOUNT_INACTIVE') return 'inactive';
  if (error.status === 403) return 'noAccount';
  if (error.status === 401) return 'refused';
  if (error.status === 422) return 'expired';
  return 'failed';
}

/** 409 from start: the platform has no Google client configured. */
export function isGoogleUnavailable(error: unknown): boolean {
  return error instanceof ApiError && error.code === 'GOOGLE_SIGN_IN_UNAVAILABLE';
}
